<template>
  <v-container
    id="detalhe-clientes-maiores-clientes-form"
    fluid
    tag="section"
    class="px-3 pt-0"
    style="margin-top: 1rem"
  >
    <v-row>
      <v-col
        cols="12"
        lg="12"
        class="px-1"
      >
        <v-row>
          <v-col
            cols="12"
            class="container"
          >
            <v-container>
              <dashboard-filtro-datas
                :primeiro="enablePrimeiroDia"
                :ultimo="enableUltimoDia"
                :empresas="enableEmpresa"
                :vendedores="enableVendedor"
                :supervisores="enableSupervisor"
                :areas="enableArea"
                :redes="enableRede"
                :receitas="enableReceita"
                :segmentos="enableSegmento"
                :cliente="enableClientes"
              />
            </v-container>
            <v-row>
              <v-col
                cols="12"
                sm="12"
                md="12"
                lg="12"
              >
                <div>
                  <v-row>
                    <v-col
                      cols="12"
                      sm="12"
                      md="12"
                      lg="12"
                    >
                      <v-card
                        id="cardDashbord"
                        class="mx-auto"
                        outlined
                      >
                        <div class="card-header-dashbord">
                          <v-row>
                            <v-col
                              cols="12"
                              sm="9"
                              md="9"
                              lg="9"
                              class="d-flex flex-wrap"
                            >
                              Quais são aqueles que mais estão crescendo?
                            </v-col>
                            <v-col
                              cols="12"
                              sm="1"
                              md="1"
                              lg="1"
                              class="d-flex justify-end"
                            >
                              <v-btn
                                id="btnPrint"
                                class="col-12 lg-12"
                                small
                                :color="corPrimaria"
                                dark
                                :disabled="enableBtn"
                                :loading="imprimindo"
                                @click="imprimir()"
                              >
                                <v-icon>
                                  mdi-printer
                                </v-icon>
                                Imprimir
                                <template v-slot:loader>
                                  <span>Imprimindo...</span>
                                </template>
                              </v-btn>
                            </v-col>
                            <v-col
                              cols="12"
                              sm="2"
                              md="2"
                              lg="2"
                              class="d-flex justify-end"
                            >
                              <v-tooltip
                                top
                                max-width="400"
                                width="400"
                              >
                                <template
                                  v-slot:activator="{ on, attrs }"
                                >
                                  <v-icon
                                    id="iconInformationDevolucaoClientes"
                                    class="text-left"
                                    v-bind="attrs"
                                    v-on="on"
                                    @mouseover="enableTexto('330')"
                                  >
                                    mdi-information-outline
                                  </v-icon>
                                </template>
                                <div
                                  v-if="!carregandoTooltip"
                                  v-html="textoOrientacao"
                                />
                              </v-tooltip>
                            </v-col>
                          </v-row>
                        </div>
                        <v-card-actions>
                          <div
                            v-if="loading"
                            :style="styleObject"
                            class="text-center"
                          >
                            <v-icon
                              light
                              class="custom-loader"
                              :style="styleObject"
                            >
                              mdi-cached
                            </v-icon>
                            Carregando dados...
                          </div>
                          <div
                            v-else-if="error"
                            class="alert alert-danger"
                          >
                            {{ error }}
                          </div>
                          <div
                            v-else
                          >
                            <v-row>
                              <v-col
                                cols="12"
                                sm="12"
                                md="12"
                                lg="12"
                              >
                                <div
                                  id="idTable"
                                  style="overflow-x: auto; max-width: 100%;"
                                >
                                  <table
                                    style="width: 100%; table-layout: fixed; color: black; border-collapse: collapse;"
                                    class="elevation-1"
                                  >
                                    <thead>
                                      <tr>
                                        <th
                                          id="dadoMovimentacaoHeader"
                                          style="text-align: center;"
                                          class="black--text title"
                                        >
                                          Cliente
                                        </th>
                                        <th
                                          id="dadoMovimentacaoHeader"
                                          style="text-align: center;"
                                          class="black--text title"
                                        >
                                          Fat. Anual Acumulado
                                        </th>
                                        <th
                                          id="dadoMovimentacaoHeader"
                                          style="text-align: center;"
                                          class="black--text title"
                                        >
                                          Fat. Acumu. Ano Anterior
                                        </th>
                                        <th
                                          id="dadoMovimentacaoHeader"
                                          style="text-align: center;"
                                          class="black--text title"
                                        >
                                          Variação Faturamento
                                        </th>
                                        <th
                                          id="dadoMovimentacaoHeader"
                                          style="text-align: center;"
                                          class="black--text title"
                                        >
                                          Quant. Anual Acumulado
                                        </th>
                                        <th
                                          id="dadoMovimentacaoHeader"
                                          style="text-align: center;"
                                          class="black--text title"
                                        >
                                          Quant. Acumu. Ano Anterior
                                        </th>
                                        <th
                                          id="dadoMovimentacaoHeader"
                                          style="text-align: center;"
                                          class="black--text title"
                                        >
                                          Variação Quantidade
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr
                                        v-for="item in clientesMaiorCrescimento"
                                        :key="item.id"
                                      >
                                        <td
                                          id="dadoMovimentacao"
                                          style="text-align: left;"
                                        >
                                          {{ item.nome_cliente }}
                                        </td>
                                        <td
                                          id="dadoMovimentacao"
                                          style="text-align: right;"
                                        >
                                          {{ item.faturamento }}
                                        </td>
                                        <td
                                          id="dadoMovimentacao"
                                          style="text-align: right;"
                                        >
                                          {{ item.faturamento_anterior }}
                                        </td>
                                        <td
                                          id="dadoMovimentacao"
                                          style="text-align: right;"
                                          :style="getColor()"
                                        >
                                          {{ item.variacao }}
                                        </td>
                                        <td
                                          id="dadoMovimentacao"
                                          style="text-align: right;"
                                        >
                                          {{ item.quantidade }}
                                        </td>
                                        <td
                                          id="dadoMovimentacao"
                                          style="text-align: right;"
                                        >
                                          {{ item.quantidade_aterior }}
                                        </td>
                                        <td
                                          id="dadoMovimentacao"
                                          style="text-align: right;"
                                          :style="getColor()"
                                        >
                                          {{ item.variacao_quatindade }}
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </v-col>
                            </v-row>
                          </div>
                        </v-card-actions>
                      </v-card>
                    </v-col>
                  </v-row>
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <dashboard-core-snackbar
      v-model="snackbar.visible"
      :visible="snackbar.visible"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      :message="snackbar.message"
    />
  </v-container>
</template>

<script>
  import Clientes from '../../../../../services/somentecliente'
  import Permissao from '../../../../../services/menu'
  import eventEmit from '../../../components/core/EventoEmit'
  import JSPDF from 'jspdf'
  import 'jspdf-autotable'

  export default {
    name: 'ShowDetalheDadosPerfomance',
    emits: ['atualizarTexto'],
    components: {
      DashboardCoreSnackbar: () => import('../../../components/core/Snackbar'),
      DashboardFiltroDatas: () => import('../../../components/core/FiltroDatas'),
    },
    data: () => ({
      appOnline: navigator.onLine,
      corPrimaria: localStorage.corPrimaria,
      corSecondaria: localStorage.corSecondaria,
      styleObjectIcon: {
        color: '#4780b8',
      },
      styleObject: {
        color: localStorage.corPrimaria,
      },
      valorReceber: localStorage.valorReceber,
      valorVencido: 0,
      paginaEnable: false,
      permissaoContasReceber: '',
      primeiroDia: (new Date(localStorage.dataInicial)).toISOString().substr(0, 10),
      ultimoDia: (new Date(localStorage.dataFinal)).toISOString().substr(0, 10),
      enablePrimeiroDia: true,
      enableUltimoDia: true,
      enableEmpresa: true,
      enableVendedor: true,
      enableSupervisor: true,
      enableArea: true,
      enableRede: true,
      enableReceita: true,
      enableSegmento: true,
      enableClientes: true,
      select: [],
      vendedorSelect: [],
      areaSelect: [],
      redeSelect: [],
      supervisorSelect: [],
      receitaIds: [],
      segmento: [],
      selectCategoria: [],
      selectPromotor: [],
      selectClassificacao: [],
      clientes: [],
      link: localStorage.linkClientes,
      menu: false,
      menu1: false,
      dataInicialImpressao: false,
      dataFinalImpressao: false,
      codigo: 0,
      orientacao: [],
      textoDetalhesClienteMaioresCrescimento: '',
      headersClientesMelhoresPiores: [
        { text: 'Cliente', value: 'nome_cliente', class: 'black--text title' },
        { text: 'Fat. Anual Acumulado', value: 'faturamento', align: 'right', class: 'black--text title' },
        { text: 'Fat. Acumu. Ano Anterior', value: 'faturamento_anterior', align: 'right', class: 'black--text title' },
        { text: 'Variação Faturamento', value: 'variacao', align: 'right', class: 'black--text title' },
        { text: 'Quant. Anual Acumulado', value: 'quantidade', align: 'right', class: 'black--text title' },
        { text: 'Quant. Acumu. Ano Anterior', value: 'quantidade_aterior', align: 'right', class: 'black--text title' },
        { text: 'Variação Quantidade', value: 'variacao_quatindade', align: 'right', class: 'black--text title' },
      ],
      clientesMaiorCrescimento: [],
      snackbar: {
        visible: false,
        color: 'success',
        direction: 'top center',
        message: 'My timeout is set to 3000.',
        timeout: 3000,
      },
      loading: false,
      error: null,
      enableBtn: true,
      imprimindo: false,
      textoOrientacao: '',
      carregandoTooltip: false,
      codigoAtual: null,
    }),

    computed: {
      computedDateFormatted () {
        return this.formatDate(this.ultimoDia)
      },

      computedPrimeiroDia () {
        return this.formatDatePrimeiroDia(this.primeiroDia)
      },
    },

    created () {
      eventEmit.$on('update-dados', this.handleUpdateDados)
    },

    beforeDestroy () {
      eventEmit.$off('update-dados', this.handleUpdateDados)

      window.removeEventListener('resize', this.updateDynamicPadding)
    },

    mounted () {
      if (localStorage.tokencontrato) {
        this.usuarioIdentificado = true

        this.paginaEnable = true

        eventEmit.$emit('atualizar_texto', 'Cliente')
      } else {
        this.usuarioIdentificado = false
        localStorage.removeItem('username')
        localStorage.removeItem('email')
        localStorage.removeItem('nome')
        localStorage.removeItem('usuarioIdentificado')
        this.$router.push('/login')
      }
    },

    methods: {
      handleUpdateDados (primeiroDia, dataFinal, select, vendedor, area, rede, supervisor, receita, segmento, classificacao, produto, cidade, categoria, promotor, linhasProducao, primeiroDiaStatus, dataStatus, motorista, statusEntrega, ordem, opcaoOrdenacao, orientacaoOrdem, clientes) {
        this.primeiroDia = primeiroDia
        this.ultimoDia = dataFinal
        this.select = select
        this.vendedorSelect = vendedor
        this.areaSelect = area
        this.redeSelect = rede
        this.supervisorSelect = supervisor
        this.receita = receita
        this.segmento = segmento
        this.clientes = clientes

        localStorage.setItem('updateDadosFiltros', true)
        localStorage.setItem('dataInicial', this.primeiroDia)
        localStorage.setItem('dataFinal', this.ultimoDia)
        localStorage.setItem('empresaId', JSON.stringify(this.select || []))

        this.updateDate()
      },

      updateDate () {
        this.formatarDatasImpressao()

        this.showDadosClientesMaioresCrescimento()
      },

      async enableTexto (value) {
        if (this.codigoAtual === value && this.textoOrientacao) return

        this.codigoAtual = value
        this.carregandoTooltip = true
        this.textoOrientacao = ''

        try {
          const resposta = await Permissao.showOrientacaoIndicador(localStorage.username, localStorage.tokencontrato, value)

          if (resposta.data.status) {
            this.textoOrientacao = resposta.data.orientacao
            this.codigo = value
          }
        } catch (e) {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        } finally {
          this.carregandoTooltip = false
        }
      },

      async imprimir () {
        try {
          this.imprimindo = true

          await setTimeout(() => {
            this.print()
          }, 2000)
        } catch (error) {
          console.error('Erro ao imprimir:', error)
        }
      },

      quebrarString (str, limiteCaracteresPorLinha) {
        const palavras = str.split(' ')
        let linhaAtual = ''
        const linhas = []

        palavras.forEach(palavra => {
          if ((linhaAtual + palavra).length <= limiteCaracteresPorLinha) {
            linhaAtual += palavra + ' '
          } else {
            linhas.push(linhaAtual.trim())
            linhaAtual = palavra + ' '
          }
        })

        if (linhaAtual !== '') {
          linhas.push(linhaAtual.trim())
        }

        return linhas
      },

      async print () {
        try {
          const pdf = new JSPDF('landscape', 'mm')

          // Função para adicionar tabela e controlar quebra de página
          const addTable = async (data, headers, title, posY, fontSize) => {
            pdf.text(title, 15, posY)
            posY += pdf.getTextDimensions(title).h

            pdf.autoTable({
              head: [headers.map(header => ({ content: header.text, styles: { fontSize: fontSize, textColor: [0, 0, 0] } }))],
              body: data.map(row => row.map(cell => ({ content: cell, styles: { fontSize: 8, textColor: [0, 0, 0] } }))),
              startY: posY,
              styles: { fontSize: fontSize },
            })

            posY = 20

            return posY
          }

          let posYFiltros = 10

          const title = 'Filtros selecionados'
          pdf.text(title, 105, posYFiltros)

          const dataInicial = this.primeiroDia.substr(8) + '/' + this.primeiroDia.substr(5, 2) + '/' + this.primeiroDia.substr(0, 4)
          const ultimoDia = this.ultimoDia.substr(8) + '/' + this.ultimoDia.substr(5, 2) + '/' + this.ultimoDia.substr(0, 4)

          const datas = 'Data inicial: ' + dataInicial + ' - Data final: ' + ultimoDia
          posYFiltros += 10
          pdf.setFontSize(10)
          pdf.text(datas, 15, posYFiltros)

          posYFiltros += 10

          const adicionarFiltros = async (pdf, posYFiltros, titulo, dados) => {
            if (dados.length > 0) {
              let texto = titulo + ' '

              for (let i = 0; i < dados.length; i++) {
                texto += dados[i] + ', '
              }

              texto = texto.slice(0, -2)

              const linhas = this.quebrarString(texto, 135)

              linhas.forEach((linha, index) => {
                if (posYFiltros === 200) {
                  pdf.addPage()

                  posYFiltros = 10

                  pdf.text(linha, 15, posYFiltros)

                  posYFiltros += 10
                } else {
                  pdf.text(linha, 15, posYFiltros)

                  posYFiltros += 10
                }
              })
            }

            return posYFiltros
          }

          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Empresa(s) Selecionada(s):', this.select.map(e => e.nomeExibicao))
          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Vendedor(es) Selecionado(s):', this.vendedorSelect.map(v => v.vendedor))
          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Área(s) Selecionada(s):', this.areaSelect.map(a => a.area))
          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Rede(s) Selecionada(s):', this.redeSelect.map(r => r.rede))
          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Supervisor(es) Selecionado(s):', this.supervisorSelect.map(s => s.supervisor))
          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Receita(s) Selecionada(s):', this.receita.map(re => re.nome))
          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Segmento(s) Selecionado(s):', this.segmento.map(se => se.segmento))

          if (posYFiltros > 70) {
            pdf.addPage()

            posYFiltros = 10
          }

          const titleTable = 'Quais são aqueles que mais estão crescendo?'
          const table = this.clientesMaiorCrescimento.map(item => [item.nome_cliente, item.faturamento, item.faturamento_anterior, item.variacao, item.quantidade, item.quantidade_aterior, item.variacao_quatindade])
          posYFiltros = await addTable(table, this.headersClientesMelhoresPiores, titleTable, posYFiltros, 8)

          pdf.save('relatorio_detalhe_melhores_clienes.pdf')
        } catch (error) {
          console.error('Erro ao gerar PDF:', error)
        } finally {
          this.imprimindo = false
        }
      },

      formatarDatasImpressao () {
        var partesInicial = this.primeiroDia.split('-')
        var ano = partesInicial[0]
        var mes = partesInicial[1]
        var dia = partesInicial[2]
        this.dataInicialImpressao = dia + '/' + mes + '/' + ano

        var partesFinal = this.ultimoDia.split('-')
        var anoFinal = partesFinal[0]
        var mesFinal = partesFinal[1]
        var diaFinal = partesFinal[2]
        this.dataFinalImpressao = diaFinal + '/' + mesFinal + '/' + anoFinal
      },

      async showDadosClientesMaioresCrescimento () {
        this.loading = true
        this.clientesMaiorCrescimento = []
        this.enableBtn = true

        await Clientes.showDetalheClienteMaioresCrescimento(this.primeiroDia, this.ultimoDia, this.select, this.vendedorSelect, localStorage.tokencontrato, this.areaSelect, this.redeSelect, this.supervisorSelect, this.receita, this.segmento, this.selectCategoria, this.selectPromotor, this.clientes).then(resposta => {
          if (resposta.data.status) {
            this.enableBtn = false

            this.clientesMaiorCrescimento = resposta.data.dadosMaioresClientes.map((item) => {
              var listaMelhoresClientes = ({
                nome_cliente: item.nome_cliente,
                faturamento: item.faturamento.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                faturamento_anterior: item.faturamento_anterior.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                variacao: item.variacao.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '%',
                quantidade: item.quantidade.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                quantidade_aterior: item.quantidade_aterior.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                variacao_quatindade: item.variacao_quatindade.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '%',
              })

              return listaMelhoresClientes
            })
          } else if (resposta.data.msg === 'Não há dados de devolução no período selecionado') {
            this.clientesMaiorCrescimento = []

            this.showSnackbar('error', 3000, resposta.data.msg)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => {
          this.loading = false
        })
      },

      formatDate (date) {
        if (!date) {
          return null
        }

        var dataLimite = new Date(new Date().getFullYear(), new Date().getMonth() + 3, 0).toISOString().substr(0, 10)

        if (date > dataLimite) {
          this.showSnackbar('error', 5000, 'Filtro de datas não podem ser maiores que 2 meses da data atual')

          var data = new Date(new Date().getFullYear(), new Date().getMonth() + 2, 0).toISOString().substr(0, 10)

          const [year, month, day] = data.split('-')

          return `${day}/${month}/${year}`
        }

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },

      formatDatePrimeiroDia (date) {
        if (!date) {
          return null
        }

        var dataLimite = new Date(new Date().getFullYear(), new Date().getMonth() - 2, 1).toISOString().substr(0, 10)

        if (date < dataLimite) {
          this.showSnackbar('error', 5000, 'Filtro de datas não podem ser menores que 2 meses da data atual')

          const [year, month, day] = dataLimite.split('-')

          return `${day}/${month}/${year}`
        }

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },

      parseDate (date) {
        if (!date) return null

        const [month, day, year] = date.split('/')
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
      },

      getColor () {
        return 'color: green'
      },
    },
  }
</script>

<style scoped>
  #cardDashbord {
    border-radius: 14px;
    border: 1px solid rgba(0,0,0,0.05);
    box-shadow:
      0 2px 4px rgba(0,0,0,0.08),
      0 6px 12px rgba(0,0,0,0.06),
      0 12px 24px rgba(0,0,0,0.04);
    transition: all 0.25s ease;
    transform: translateY(-3px);
    box-shadow:
      0 4px 8px rgba(0,0,0,0.10),
      0 12px 22px rgba(0,0,0,0.09),
      0 20px 32px rgba(0,0,0,0.06);
  }

  .card-header-dashbord {
    background-color: #ffffff;
    padding: 14px 18px;
    font-weight: 600;
    font-size: 14px;
    color: black;
    border-bottom: 1px solid #b7b1b1;
    border-radius: 14px 14px 0 0;
  }

  .no-list-style {
    list-style-type: none;
    padding: 0;
    margin: 0
  }

  .no-list-style li {
    text-decoration: none
  }

  .hidden {
    display: none
  }

  @media screen
  and (min-device-width : 320px)
  and (max-device-width : 680px) {
    #headersDevolucaoClientes {
      width: 100% !important;
    }

    #idTable {
      max-height: 500px;
    }

    #dadoMovimentacao {
      font-size: 8.5px !important;
    }

    th, td {
      padding: 8px;
    }
  }

  @media screen
  and (min-width : 681px)
  and (max-width : 960px)
  and (-webkit-min-device-pixel-ratio: 1) {
    #headersDevolucaoClientes {
      max-width: 100%;
    }
  }

  #idTable {
    overflow-x: auto;
    overflow-y: auto;
    max-height: 600px;
  }

   #dadoMovimentacao {
    font-size: 12px;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    font-family: Roboto, sans-serif;
    border: 1px solid #e0e0e0;
  }

  thead th {
    position: sticky;
    top: 0;
    z-index: 2;
    background-color: #f5f5f5;
  }

  th, td {
    border: 1px solid #e0e0e0;
    padding: 10px;
    color: #424242;
  }

  thead {
    background-color: #f5f5f5;
  }

  tbody tr:hover {
    background-color: #f0f0f0;
  }

  #textoTabela {
    font-size: 0.75rem !important
  }

  #dadoMovimentacaoHeader {
    font-size: 12px !important;
    font-weight: 800 !important;
  }

  .custom-loader {
    animation: loader 1s infinite;
    display: flex;
    @-moz-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-webkit-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-o-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)
  }
</style>
